<script>
	import Router from 'svelte-spa-router'
	import {link, push, pop, replace, location, querystring} from 'svelte-spa-router'
	import routes from './routes'
  import active from 'svelte-spa-router/active'

  let httpRequest;

	function makeRequest() {
		httpRequest = new XMLHttpRequest();

		if (!httpRequest) {
			alert('Abandon :( Impossible de créer une instance de XMLHTTP');
			return false;
		}

		httpRequest.onreadystatechange = alertContents;
		httpRequest.open('GET', 'https://ghislainl.gitlab.io/cardey-training/data/data.yml');
		httpRequest.send();
	}

	function alertContents() {
		if (httpRequest.readyState === XMLHttpRequest.DONE) {
			if (httpRequest.status === 200  || httpRequest.status == 304) {
				let catalog = jsyaml.load(httpRequest.responseText);
        sessionStorage.setItem('catalog', JSON.stringify(catalog));
        // let data = sessionStorage.getItem('catalog');
			} else {
				alert('Il y a eu un problème avec la requête.');
			}
		}
  }
  
  makeRequest();
</script>

<header class="">
  <a href="/" use:link use:active>Cardey training</a>
  <a href="/exercices" use:link use:active>Exercices</a>
  <a href="/about" use:link use:active>A propos</a>
  <a href="https://gitlab.com/GhislainL/cardey-training/" target="_blank">Sources</a>
</header>

<Router {routes}/>

<footer>
  Ghislain Lerda - 2020 - 
  <a rel="license" href="http://creativecommons.org/licenses/by-nc/4.0/">
    <img alt="Licence Creative Commons" style="border-width:0" src="https://i.creativecommons.org/l/by-nc/4.0/80x15.png" /></a> 
    - 
    Réalisé avec Svelte <a href="https://svelte.dev/">
      <img src="./img/svelte-logo.svg" alt="Svelte" height="20px" style="border-width:0" /></a>
</footer>

<style>
  header {
    height: 50px;
    width: 100%;
    position: absolute;
    top: 0px;
    background-color: #333;
  }

  footer {
    height: 30px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    background-color:lightgrey;
    color: black;
    text-align: center;
    padding-top: 5px;
  }
    
  /* Links inside the navbar */
  header a {
    float: left;
    display: block;
    color: #f2f2f2;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
  }
  
  /* Change background on mouse-over */
  header a:hover {
    background: #ddd;
    color: black;
  }

  header .active {
    background-color: red;
  }
</style>